export function Transformation (time) {
  /* 日期时间戳转字符串 */
  let date = new Date(time)
  let y = date.getFullYear()
  let m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  let d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return y + '-' + m + '-' + d
}
// 禁止浏览器返回
export function goBack () {
  //console.log('点击了浏览器的返回按钮')
  history.pushState(null, null, document.URL)
}



// WEBPACK FOOTER //
// ./src/utils/Transformation.js